import { render, staticRenderFns } from "./FiltrosAplicados.vue?vue&type=template&id=18fb0763&scoped=true"
import script from "./FiltrosAplicados.vue?vue&type=script&lang=js"
export * from "./FiltrosAplicados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fb0763",
  null
  
)

export default component.exports